<template>
  <v-app>
    <cabecerados/>
    <v-main>
      <v-container>
        <v-row class="text-center">
          <v-col cols="12">
            <section id="eventos">
              <v-row  class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 class="display-1 font-weight-bold">Carnet {{elnegocio}}</h1>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-btn class="primary" @click="exportarPDF">
                    <v-icon left>
                      fas fa-print
                    </v-icon>Imprimir</v-btn>
                </v-col>
              </v-row>
              <v-row justify="center" >

                <v-col cols="12" lg="8" sm="12"   >
                  <v-card id="elcarnet" ref="content" v-bind:style="styleCarnet"  elevation="10">
                    <v-card-title   ></v-card-title>
                    <v-card-text >
                      <v-row justify="center" align="center">
                        <v-col cols="12" lg="12" md="12" sm="12">
                          <v-img  class="mx-auto" width="270" :src="logo270" alt="logo"></v-img>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="6">
                          <v-img  class="mx-auto" width="200" alt="foto" :src="foto"></v-img >
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="6">
                          <v-row>
                            <v-col cols="12" lg="12" md="12" sm="12">
                              <h1 v-bind:style="styleText">{{membresia.socioPrincipal.personaNombre}} {{membresia.socioPrincipal.personaApellidoPaterno}} {{membresia.socioPrincipal.personaApellidoMaterno}}</h1>
                            </v-col>

                            <v-col cols="12" lg="12" md="12" sm="12">
                              <h2  v-bind:style="styleText">{{membresia.socioPrincipal.personaDni}}</h2>
                            </v-col>

                            <v-col cols="12" lg="12" md="12" sm="12">
                              <vue-qr :size="200" :text="membresia.codigoUnico" />
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" lg="12" md="12" sm="12">
                          <p ><span  v-bind:style="styleText" v-html="membresia.tipoCarnet.restricciones"></span></p>
                        </v-col>

                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </section>


          </v-col>
        </v-row>
        <img :src="output">

      </v-container>
    </v-main>
    <piepagina/>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>
import piepagina from "@/components/general/piepagina";
import VueQr from 'vue-qr'
import axios from "axios";
import Cabecerados from "@/components/general/cabecerados";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
export default {
  name: 'micarnet',
  title: 'Carnet | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerados,
    piepagina,
    VueQr
  },
  data () {
    return {
      overlay:false,
      alerterror: false,
      error:'',
      elnegocio:'',
      output: null,
      styleCarnet: {
        color:'white',
        backgroundImage:'',
        backgroundSize:'cover'
      },
      styleText:{
        color:''
      },
      token:'',
      idpersona:0,
      encodedPdf: "",
      logo270:'',
      foto:'',
      background:'',
      membresia:{
        tipoCarnet:{
          tipoCarnetTemporda:{
            temporadaNegocio:{
              negocio:''}
          }
        }
        },
      codigoUnico:'',
      negocio:{}
    }
  },
  mounted() {
    this.codigoUnico = this.$route.params.codigo
    if(this.codigoUnico == undefined){
      this.$router.push({ path: '/' });
    }else{
      this.traeCodigo()
    }

  },
  methods:{
    async exportarPDF(){
      const doc = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4',
        hotfixes: ['px_scaling'],
      });
      let dtr = new Date();

      html2canvas(document.getElementById("elcarnet"), {
        width: doc.internal.pageSize.getWidth(),
        height: doc.internal.pageSize.getHeight(),
        allowTaint: true,
        useCORS: true,
        logging: true,
        proxy: this.membresia.tipoCarnet.tipoCarnetBackFront
      }).then((canvas) => {
        var img = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

        doc.addImage(img, "PNG", 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
        doc.save("Carnet_"+dtr+".pdf");
      })
    },
    convertImgUrlToBase64(url,what) {
      let self = this;
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); // use it if you try in a different origin of your web

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        canvas.getContext('2d').drawImage(this, 0, 0);

        canvas.toBlob(
            function(source) {
              var newImg = document.createElement("img"),
                  url = URL.createObjectURL(source);

              newImg.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
              };

              newImg.src = url;
            },
            "image/jpeg",
            1
        );

        // If you ever stumble at 18 DOM Exception, just use this code to fix it
        // let dataUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let dataUrl = canvas.toDataURL("image/jpeg");
        console.log("cek inside url : ", url);

        if(what === "background"){
          self.styleCarnet.backgroundImage = "url('"+ dataUrl+"')"
        }
        if(what === "foto"){
          self.foto = dataUrl
        }

      };
      image.src = url;
    },
    convertImgUrlToBase64Png(url,what) {
      let self = this;

      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); // use it if you try in a different origin of your web

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        canvas.getContext('2d').drawImage(this, 0, 0);

        canvas.toBlob(
            function(source) {
              var newImg = document.createElement("img"),
                  url = URL.createObjectURL(source);

              newImg.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
              };

              newImg.src = url;
            },
            "image/png",
            1
        );

        // If you ever stumble at 18 DOM Exception, just use this code to fix it
        // let dataUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let dataUrl = canvas.toDataURL("image/png");
        console.log("cek inside url : ", url);
       if(what === "logo"){
         self.logo270 = dataUrl
       }

      };
      image.src = url;
    },
    traeCodigo(){
      this.overlay = true
      axios
          .get('membresia/codigo/'+this.codigoUnico.trim())
          .then((response)  => {
            this.membresia = response.data;
          this.elnegocio =   this.membresia.tipoCarnet.tipoCarnetTemporada.temporadaNegocio.negocio
         //   this.styleCarnet.backgroundImage = 'url(' + this.membresia.tipoCarnet.tipoCarnetBackFront + ')'
            this.styleCarnet.color = this.membresia.tipoCarnet.tipoCarnetTextColor
            this.styleText.color = this.membresia.tipoCarnet.tipoCarnetTextColor
            this.convertImgUrlToBase64Png(this.membresia.tipoCarnet.tipoCarnetTemporada.temporadaNegocio.negocioLogo270,"logo")
            this.convertImgUrlToBase64(this.membresia.socioPrincipal.personaFoto,"foto")
           this.convertImgUrlToBase64(this.membresia.tipoCarnet.tipoCarnetBackFront,"background")
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    }
  }
}
</script>